import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { SubmissionError } from 'redux-form';
import { Modal } from 'synfrastructure';
import config from '../config';
import Icon from '../common/icons/Icon';
import { selectActiveUser } from './selectors';
import { formatValidationErrors } from '../common/utils/getApiReducer';
import Breadcrumb from '../common/components/Breadcrumb';
import UnlockCourseForm from './UnlockCourseForm';
import ChangeEmailForm from './ChangeEmailForm';
import TwoStepButton from '../common/components/TwoStepButton';
import {
  changeEmail,
  forceForgotPassword,
  makeUserMovementSpecialist,
  unlockCourse
} from './actions';

class UserEditPage extends Component {
  static propTypes = {
    activeUser: PropTypes.object,
    initialValues: PropTypes.object,
  };

  state = {
    unlockCourseModalVisible: false,
    passwordChangedMessageVisible: false,
    changeEmailModalVisible: false,
    changeEmailMessageVisible: false,
  };

  toggleUnlockCourseModal = () => {
    this.setState(state => ({ unlockCourseModalVisible: !state.unlockCourseModalVisible }));
  };

  onMakeUserMovementSpecialist = () => {
    const { dispatch, activeUser } = this.props;

    dispatch(makeUserMovementSpecialist(activeUser.id));
  };

  onUnlock = course => {
    const { dispatch, activeUser } = this.props;

    dispatch(unlockCourse(activeUser.id, course)).then(action => {
      if (action.response.ok) {
        this.setState({ unlockCourseModalVisible: false });
      }
    });
  };

  onForceResetPassword = async () => {
    const { dispatch, activeUser } = this.props;
    const action = await dispatch(forceForgotPassword(activeUser.id, config.auth.clientId, config.auth.redirectUri))
    if (action.response.ok) {
      this.setState({
        passwordChangedMessageVisible: true,
        changeEmailMessageVisible: false
      });
    }
  };

  toggleChangeEmailModal = () => {
    this.setState(state => ({ changeEmailModalVisible: !state.changeEmailModalVisible }));
  };

  onChangeEmail = async ({ email }) => {
    const { dispatch, activeUser } = this.props;
    const action = await dispatch(changeEmail(activeUser.id, email, config.auth.clientId, config.auth.membersFrontendUri))
    if (!action.response.ok) {
      throw new SubmissionError(formatValidationErrors(action.json).toJS());
    } else {
      this.toggleChangeEmailModal();
      this.setState({
        passwordChangedMessageVisible: false,
        changeEmailMessageVisible: true
      });
    }
  }

  render() {
    const { activeUser, location, makeMovementSpecialist, unlockCourse } = this.props;
    const {
      changeEmailModalVisible,
      changeEmailMessageVisible,
      passwordChangedMessageVisible,
      unlockCourseModalVisible,
      changeEmailError,
    } = this.state;

    const breadcrumbs = [
      {
        label: 'User List',
        to: `/users${location.search}`,
      },
      {
        label: activeUser.name,
        to: null,
      },
    ];

    const userIsMovementSpecialist = !!activeUser.roles.find(role => role === 'ms');

    return (
      <div className="admin-paper">
        {unlockCourseModalVisible && (
          <Modal isVisible onClose={this.toggleUnlockCourseModal}>
            <UnlockCourseForm
              loading={unlockCourse.get('loading')}
              onSubmit={this.onUnlock}
              onCancel={this.toggleUnlockCourseModal}
              unlockedCourses={activeUser.unlockedCourses}
            />
          </Modal>
        )}
        <Modal isVisible={changeEmailModalVisible} onClose={this.toggleChangeEmailModal}>
          <ChangeEmailForm onSubmit={(values) => this.onChangeEmail(values)} onCancel={this.toggleChangeEmailModal} error={changeEmailError} />
        </Modal>
        <div className="admin-paper__header">
          <Breadcrumb crumbs={breadcrumbs} />
          <button onClick={this.toggleUnlockCourseModal} className="admin__add-button">
            <Icon icon="Plus" /> Add Unlocked Course
          </button>
        </div>
        <div>
          <div className="admin-paper__edit-content" key="movementSpecialist-info">
            <div className="admin-paper__edit-content__row">
              <p>Name</p>
              <span>{activeUser.name}</span>
            </div>
            <div className="admin-paper__edit-content__row">
              <p>Email</p>
              <span>{activeUser.email}</span>
            </div>
            <div className="admin-paper__edit-content__row">
              <p>Phone</p>
              <span>{activeUser.phone}</span>
            </div>
            <div className="admin-paper__edit-content__row">
              <p>Movement Specialist</p>
              <span>{userIsMovementSpecialist ? 'Yes' : 'No'}</span>
            </div>
            {!userIsMovementSpecialist && (
              <div className="admin-paper__edit-button">
                <TwoStepButton
                  buttonText="Make User a Movement Specialist"
                  className="button"
                  disabled={makeMovementSpecialist.get('loading')}
                  onConfirm={this.onMakeUserMovementSpecialist}
                />
              </div>
            )}
            <div className="admin-paper__edit-content__row">
              <p>
                <button className="button" onClick={this.toggleChangeEmailModal}>
                  Change Email
                </button>
              </p>
              <p>
                <button className="button" onClick={this.onForceResetPassword}>
                  Reset Password
                </button>
              </p>
              {passwordChangedMessageVisible && (
                <span style={{ marginTop: '14px' }}>Forgot Password mechanism initialized.</span>
              )}
              {changeEmailMessageVisible && (
                <span style={{ marginTop: '14px' }}>Email changed. User needs to confirm email.</span>
              )}
            </div>
          </div>
        </div>
        <div className="admin-paper">
          <div className="admin-paper__header">
            <h3>Unlocked Courses</h3>
          </div>
          <ul className="admin-paper__list">
            {activeUser.unlockedCourses.length ? (
              activeUser.unlockedCourses.map(course => (
                <li key={`course-${course.id}`}>
                  <div className="admin-paper__list__title">
                    <Icon icon="Flag" />
                    {course.name}
                  </div>
                </li>
              ))
            ) : (
              <div className="admin-paper__no-content">No Unlocked Courses</div>
            )}
          </ul>
        </div>
      </div>
    );
  }
}

export default connect((state, ownProps) => ({
  activeUser: selectActiveUser(state, ownProps.match.params.id),
  makeMovementSpecialist: state.users.makeMovementSpecialist,
  unlockCourse: state.users.unlockCourse,
}))(UserEditPage);



// WEBPACK FOOTER //
// ./src/users/UserEditPage.js